import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['sure', 'counter', 'submit']

  connect() {
    this.count()
  }

  toggleAll(event) {
    this.sureTargets.forEach(input => { input.checked = event.target.checked })
    this.count()
  }

  count() {
    const chosen = [...this.element.querySelectorAll('input[name^="selections["]:checked')]
      .filter(input => input.value !== '').length

    if (this.hasCounterTarget) this.counterTarget.textContent = chosen
    if (this.hasSubmitTarget)  this.submitTarget.disabled = chosen === 0
  }
}
